import styled from "styled-components";

export const HaulierInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: 20px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: self-start;
  margin-bottom: 10px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: 0.25rem;
  font-weight: normal;
`;

export const SubTitle = styled.div`
  justify-self: auto;
  color: #767676;
  font-size: 14px;
  font-weight: 400;
  padding-left: 12px;
  margin-bottom: 10px;
  word-break: break-all;
  padding-right: 10px;
`;

export const SubTitleBold = styled.div`
  justify-self: auto;
  color: #004c7f;
  font-size: 14px;
  font-weight: 700;
  padding-left: 0px;
  margin-bottom: 10px;
  flex-shrink: 0;
  width: 42%;
`;

export const FlexRowEmpty = styled.div`
  display: flex;
  align-items: self-start;
  margin-bottom: 2.5rem;
`;
